import {Heading, Text} from '@primer/react-brand'
import Markdown, {type Components} from 'react-markdown'

import {ThankYou} from '../ThankYou/ThankYou'
import type {GitHubAppWaitlistCopy, GitHubAppWaitlistFormData} from '../../Index.data'

import Styles from './Form.module.css'
import {FormContent} from './FormContent/FormContent'

const REQUIREMENT_MESSAGE_COMPONENTS: Components = {
  p: ({children}) => (
    <Text as="p" className={Styles['Form__requirementMessage']} variant="muted" size="100">
      {children}
    </Text>
  ),
  strong: ({children}) => <span>{children}</span>,
}

const DISCLAIMER_COMPONENTS: Components = {
  p: ({children}) => (
    <Text as="p" className={Styles['Form__disclaimer']} variant="muted" size="100">
      {children}
    </Text>
  ),
}

export interface FormProps {
  isFormSubmitted: boolean
  form: {
    copy: GitHubAppWaitlistCopy['form']
    data: GitHubAppWaitlistFormData
  }
  thankYou: {
    heading: string
    body: string
  }
}

export const Form = ({isFormSubmitted, form, thankYou}: FormProps) => {
  return (
    <div id={form.copy.anchorId} className={Styles['Form']}>
      {isFormSubmitted ? (
        <ThankYou {...thankYou} />
      ) : (
        <>
          <Heading as="h3" size="5" className={Styles['Form__heading']} weight="normal">
            {form.copy.heading}
          </Heading>
          <Markdown components={REQUIREMENT_MESSAGE_COMPONENTS}>{form.copy.requirementMessage}</Markdown>

          <FormContent data={form.data} />

          <Markdown components={DISCLAIMER_COMPONENTS}>{form.copy.disclaimer}</Markdown>
        </>
      )}
    </div>
  )
}
